import React, { FC, ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { StyledSideBarLink } from '.'

type Props = {
  url: string;
  notification?: number | string;
  icon: ReactNode;
  children: ReactNode;
  id?: string;
  target?: '_blank' | '_self';
  isExact?: boolean;
  isNew?: boolean;
  [x: string]: any;
}

const SideBarLink: FC<Props> = ({
  url,
  notification,
  icon,
  children,
  id,
  target,
  isExact,
  isNew,
  ...props
}) => {
  const location = useLocation()

  return (
    <StyledSideBarLink
      className="sidebar-link-container"
      activeClassName="active"
      exact={isExact}
      to={{ pathname: url, state: { from: location.pathname } }}
      target={target}
      id={id}
      {...props}
    >
      <div className="sidebar-link">
        <div className="link-icon">
          {icon}
          {notification !== undefined && notification !== 0 && (
            <div className="link-notification">{notification}</div>
          )}
        </div>
        <div className="link-label">
          {children}
          {isNew && <div className="new-label">NEW</div>}
        </div>
      </div>
    </StyledSideBarLink>
  )
}

export default SideBarLink
